import { render, staticRenderFns } from "./ModelEdit.vue?vue&type=template&id=3c247a28"
import script from "./ModelEdit.vue?vue&type=script&lang=js"
export * from "./ModelEdit.vue?vue&type=script&lang=js"
import style0 from "./ModelEdit.vue?vue&type=style&index=0&id=3c247a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports